var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.22 18.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "eye") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.49,23.44c-5.09,0-13.58,4.13-13.58,9.22s8.48,9.22,13.58,9.22,14.65-4.13,14.65-9.22S36.58,23.44,31.49,23.44ZM35.8,37a6.09,6.09,0,0,1-10.4-4.09,6.05,6.05,0,0,0,6.31-6.32A6.09,6.09,0,0,1,35.8,37Z",
    transform: "translate(-17.91 -23.44)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.697727780d9285c6884674e9d72f7900.svg";
export { ForwardRef as ReactComponent };